export var InputLabelStateType;
(function (InputLabelStateType) {
    InputLabelStateType["DISABLED_FILLED"] = "DISABLED_FILLED";
    InputLabelStateType["DISABLED_EMPTY"] = "DISABLED_EMPTY";
    InputLabelStateType["ERROR_FILLED"] = "ERROR_FILLED";
    InputLabelStateType["ERROR_EMPTY"] = "ERROR_EMPTY";
    InputLabelStateType["FOCUSED"] = "FOCUSED";
    InputLabelStateType["EMPTY"] = "EMPTY";
    InputLabelStateType["FILLED"] = "FILLED";
})(InputLabelStateType || (InputLabelStateType = {}));
//# sourceMappingURL=state.js.map